import { render, staticRenderFns } from "./BillingAddressForm.vue?vue&type=template&id=5a387826&"
import script from "./BillingAddressForm.vue?vue&type=script&lang=js&"
export * from "./BillingAddressForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports